import { Icon, type IconTypes } from '@procurify/ui'
import { type IntlShape } from 'react-intl'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ExpenseTypeLabelStyled } from './styles/ExpenseTypeLabelStyled'
import {
  ExpenseTypes,
  type ExpenseTypeEnum,
} from '../../entities/enums/ExpenseTypeEnum'

const EXPENSE_TYPE_ICON_MAP: Record<ExpenseTypeEnum, IconTypes> = {
  [ExpenseTypes.OTHER]: 'other',
  [ExpenseTypes.MEALS]: 'meals',
  [ExpenseTypes.MILEAGE]: 'mileage',
  [ExpenseTypes.LABOUR]: 'labour',
  [ExpenseTypes.AIRFARE]: 'flight',
  [ExpenseTypes.LODGING]: 'lodge',
}

const getLabel = (intl: IntlShape, type: ExpenseTypeEnum): string => {
  switch (type) {
    case ExpenseTypes.OTHER:
      return intl.formatMessage(messages.expenseTypeOther)
    case ExpenseTypes.MEALS:
      return intl.formatMessage(messages.expenseTypeMeals)
    case ExpenseTypes.MILEAGE:
      return intl.formatMessage(messages.expenseTypeMileage)
    case ExpenseTypes.LABOUR:
      return intl.formatMessage(messages.expenseTypeLabour)
    case ExpenseTypes.AIRFARE:
      return intl.formatMessage(messages.expenseTypeAirfare)
    case ExpenseTypes.LODGING:
      return intl.formatMessage(messages.expenseTypeLodging)
  }
}

export interface IExpenseTypeLabelProps {
  type: ExpenseTypeEnum
}

export const ExpenseTypeLabel = ({ type }: IExpenseTypeLabelProps) => {
  const intl = useProcurifyIntl()
  const icon = EXPENSE_TYPE_ICON_MAP[type]
  const label = getLabel(intl, type)

  return (
    <ExpenseTypeLabelStyled>
      <Icon icon={icon} size={14} color='darkGrey' />
      {label}
    </ExpenseTypeLabelStyled>
  )
}
